// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zG0F","label":"styles_label__2qz0r"};